export class Operations {
    static readonly CanManagePublicDocument: string = 'CanManagePublicDocument';
    static readonly CanCreateUser: string = 'CanCreateUser';
    static readonly CanPlaceOrder: string = 'CanPlaceOrder';
    static readonly CanViewResult: string = 'CanViewResult';
    static readonly CanImpersonate: string = 'CanImpersonate';
    static readonly CanViewDashboard: string = 'CanViewDashboard';
    static readonly CanImpersonateAnyone: string = 'CanImpersonateAnyone';
    static readonly CanViewInvoices: string = 'CanViewInvoices';
    static readonly CanEditLimitsAndAlerts: string = 'CanEditLimitsAndAlerts';
    static readonly CanManageNewsFeed: string = 'CanManageNewsFeed';
    static readonly CanManageDefaultReport: string = 'CanManageDefaultReport';
    static readonly CanPlaceOrderSubmissionForm: string = 'CanPlaceOrderSubmissionForm';
    static readonly CanOnlyPlaceOrderSubmissionForm: string = 'CanOnlyPlaceOrderSubmissionForm';
    static readonly CanManageAlerts: string = 'CanManageAlerts';
    static readonly CanViewPrices: string = 'CanViewPrices';
    static readonly CanManageOrderingConfigurations: string = 'CanManageOrderingConfigurations';
    static readonly CanConfigureEOL: string = 'CanConfigureEOL';
    static readonly CanManageAssessment: string = 'CanManageAssessment';
    static readonly CanViewAssessment: string = 'CanViewAssessment';
    static readonly CanExpressOrdering: string = 'CanExpressOrdering';
    static readonly CanEditSurveyExclusionList: string = 'CanEditSurveyExclusionList';
    static readonly CanPerformSampling: string = 'CanPerformSampling';
    static readonly CanViewQuotationExpirationDate: string = 'CanViewQuotationExpirationDate';
    static readonly CanManageLabContacts: string = 'CanManageLabContacts';
    static readonly CanManageAndPlaceOrderforProducts: string = 'CanManageAndPlaceOrderforProducts';
    static readonly CanViewSampleAssessmentStatistics: string = 'CanViewSampleAssessmentStatistics';
    static readonly CanPlaceMobileOrders: string = 'CanPlaceMobileOrders';
    static readonly CanViewResultOnlyIfARRecipient: string = 'CanViewResultOnlyIfARRecipient';
    static readonly CanPlaceGuidedOrder: string = 'CanPlaceGuidedOrder';
}
